import {
    GetProvinces,
    GetCitys,
    GetAreas
} from '@api/commonApi.js';
import {
    util
} from 'utils';
import {
    lg
} from 'utils';

export default {
    methods: {
        //获取省份列表
        getProvinces(options) {
            let opts = $.extend({}, {
                provincesId: "",
                successCallBack: null
            }, options);
            let Params = {
                Sid: this.sysSid,
                Session: this.sysSession
            };
            this.proLoading = true;

            GetProvinces(Params).then(res => {
                util.doResult(this, res, () => {
                    this.provinceList = res.data.Data;
                    this.proLoading = false;
                    if ($.trim(opts.provincesId).length > 0) {
                        this.result.Provinces_Id = opts.provincesId;
                    }
                    if (typeof opts.successCallBack == "function") {
                        this.$nextTick(() => {
                            opts.successCallBack();
                        });
                    }
                });
            });
        },
        //根据省份获取城市列表
        getCity(options) {
            let opts = $.extend({}, {
                provincesId: "",
                cityId: "",
                successCallBack: null
            }, options);
            if ($.trim(opts.provincesId) == 0) {
                return;
            }

            let Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                ProvinceId: opts.provincesId
            };
            this.cityLoading = true;
            GetCitys(Params).then(res => {
                util.doResult(this, res, () => {
                    this.result.City_Id = null;
                    this.cityList = res.data.Data;
                    if ($.trim(opts.cityId).length > 0 && opts.cityId !== 0) {
                        this.result.City_Id = opts.cityId;
                    } else if (!this.cityValue) {
                        this.result.City_Id = this.cityList[0].Id;
                    }
                    this.cityLoading = false;
                    if (typeof opts.successCallBack == "function") {
                        this.$nextTick(() => {
                            opts.successCallBack();
                        });
                    }
                });
            });
        },
        //根据城市获取区/县列表
        getArea(options) {
            let opts = $.extend({}, {
                cityId: "",
                areaId: "",
                successCallBack: null
            }, options);
            if ($.trim(opts.cityId).length == 0) {
                return;
            }
            //if (typeof this.result.City_Id !== 'number') return;
            let Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                CityId: opts.cityId
            };
            this.areaLoading = true;
            GetAreas(Params).then(res => {
                util.doResult(this, res, () => {
                    this.result.Area_Id = null;
                    this.areaList = res.data.Data;
                    this.areaList.splice(0, 0, {
                        "Id": "",
                        "Name": "请选择"
                    });
                    if ($.trim(opts.areaId).length > 0 && opts.areaId !== 0) {
                        this.result.Area_Id = opts.areaId;
                    } else {
                        if (this.areaList.length > 0) {
                            this.result.Area_Id = this.areaList[0].Id;
                        } else {
                            this.result.Area_Id = "";
                        }
                    }
                    this.areaLoading = false;
                    this.formShow = false;
                    this.formShow = true;

                    if (typeof opts.successCallBack == "function") {
                        this.$nextTick(() => {
                            opts.successCallBack();
                        });
                    }
                });
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/common/components/area-select/services.js